export default {
  Email: 'email',
  Code: 'code',
  Password: 'password',
};
